import React from "react";

export default function RefundPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800">
      <h1 className="text-3xl font-bold text-[#264790] mb-8">Refund Policy</h1>

      <h2 className="text-xl font-semibold mb-4">Overview</h2>
      <p className="mb-4">
        Our refund and returns policy lasts <strong>15 days</strong>. If 15 days have passed since your purchase, we can’t offer you a full refund.
      </p>
      <p className="mb-4">
        Several types of goods are exempt from being returned.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-4">Non-returnable Items</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>eLearning Courses</li>
      </ul>
      <p>
        To complete your return, we require a receipt or proof of purchase.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-4">Partial Refunds</h2>
      <p className="mb-4">Certain situations allow only partial refunds:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Digital Course with obvious signs of use</li>
        <li>Digital Course returned after 15 days of purchase</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-4">Refunds</h2>
      <p className="mb-4">
        Once your return is received and inspected, we’ll email you to notify you about the approval or rejection of your refund.
        If approved, your refund will be processed and a credit will be applied to your original method of payment within a few days.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-4">Late or Missing Refunds</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>First, check your bank account again.</li>
        <li>Then contact your credit card company — it may take time before your refund is posted.</li>
        <li>Next, contact your bank — there’s often some processing delay before refunds appear.</li>
      </ul>
      <p>
        If you’ve done all this and still haven’t received your refund, please contact us at <a href="mailto:10th.guru1@gmail.com" className="text-blue-600">10th.guru1@gmail.com</a>.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-4">Exchanges</h2>
      <p className="mb-4">
        We only replace courses if they were purchased by mistake. If you need to exchange it for the same course, contact us at{" "}
        <a href="mailto:svalearn360@gmail.com" className="text-blue-600">svalearn360@gmail.com</a> and send your details to:
      </p>
      <address className="italic">
        svalearn360,<br />
        KHB Colony,<br />
        Bangalore – 560079, Karnataka, India
      </address>

      <h2 className="text-xl font-semibold mt-8 mb-4">Shipping Returns</h2>
      <p className="mb-4">
        Not applicable as we sell only digital products.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-4">Need Help?</h2>
      <p>
        For any questions about refunds and returns, contact us at{" "}
        <a href="mailto:svalearn360@gmail.com" className="text-blue-600">svalearn360@gmail.com</a>.
      </p>
    </div>
  );
}
